// To support IE11

export const parseInt = str => {
  if (Number.parseInt === undefined) {
    Number.parseInt = window.parseInt;
  }

  return Number.parseInt(str);
};

export const isArray = ref => {
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };
  }

  return Array.isArray(ref);
};

export const includes = ref => {
  if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
      "use strict";
      if (typeof start !== "number") {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }

  return ref.toString().includes("e");
};



// WEBPACK FOOTER //
// ./src/js/polyfill.js